/* ──────────────────────────────────────────────────────────────
 *  BetaTestingDialog — Beta bushing type notice
 *
 *  Shown when the user selects a bushing type that is still in
 *  beta. Reads the current bushing type from useBushingStore.
 *
 *  Ported from BushingApp.beta_testing_dialog (optibush.py).
 * ────────────────────────────────────────────────────────────── */

import React from 'react';
import Button from '@mui/material/Button';
import InfoIcon from '@mui/icons-material/Info';

import DialogShell from '@/components/DialogShell';
import { useUIStore } from '@/stores/useUIStore';
import { useBushingStore } from '@/stores/useBushingStore';

const BetaTestingDialog: React.FC = () => {
  const open = useUIStore((s) => s.betaTestingDialogOpen);
  const closeDialog = useUIStore((s) => s.closeDialog);
  const bushingType = useBushingStore((s) => s.bushingType);

  const handleClose = () => closeDialog('betaTestingDialog');

  return (
    <DialogShell
      open={open}
      onClose={handleClose}
      title={`${bushingType} — Beta Testing Notice`}
      titleColor="info.main"
      icon={<InfoIcon color="info" sx={{ fontSize: 28 }} />}
      maxWidth={550}
      actions={
        <Button variant="contained" color="info" onClick={handleClose}>
          OK
        </Button>
      }
    >
      This bushing type is in beta. We're still polishing things, so some
      behaviors may change as we improve the experience.
    </DialogShell>
  );
};

export default BetaTestingDialog;
